/** The built-in carom variant rule configs. Adding a style = adding a config. */
import type { VariantId } from '../config';
import type { CaromRuleConfig } from './types';

export const STRAIGHT_RAIL: CaromRuleConfig = {
  id: 'straight-rail',
  displayName: '4 Ball (사구)',
  minCushions: 0,
  cushionWindow: 'beforeSecond',
  pointsPerCarom: 1,
  foulOnOffTable: true,
  foulOnNoContact: true,
  // Any foul (no contact, off-table, or touching the opponent ball) counts you
  // backward by one carom — +10 on the countdown.
  foulPenalty: 1,
  breakRequiresFirstHit: null,
  // Korean four-ball (4구): a point requires caroming off both red object balls.
  caromObjectBalls: ['red', 'red2'],
  // Touching the opponent's cue ball is a foul, even if both reds were struck.
  foulOnOpponentBall: true,
  // The game-winning carom must be a 3-cushion shot: after clearing the handicap
  // (e.g. all ten caroms of a 100 game), the player must bank three cushions
  // before the second red — bank-first or between the reds — to actually win.
  finalShotMinCushions: 3,
  // Default house finish: a single qualifying 3-cushion carom wins, no bank
  // required. Online rooms may raise these (e.g. 2 caroms / 1 bank for 2v2,
  // which needs 3 total final shots: 2 plain + 1 bank — see finalBankCount).
  finalShotCount: 1,
  finalBankCount: 0,
};

export const THREE_CUSHION: CaromRuleConfig = {
  id: 'three-cushion',
  displayName: '3 Cushion (삼구)',
  minCushions: 3,
  cushionWindow: 'beforeSecond',
  pointsPerCarom: 1,
  foulOnOffTable: true,
  foulOnNoContact: true,
  foulPenalty: 0,
  breakRequiresFirstHit: 'red',
};

export const VARIANTS: Record<VariantId, CaromRuleConfig> = {
  'straight-rail': STRAIGHT_RAIL,
  'three-cushion': THREE_CUSHION,
};

export function getVariant(id: VariantId): CaromRuleConfig {
  return VARIANTS[id];
}
